import classNames from 'classnames'
import DrawMenu from 'components/drawer/DrawMenu'
import preventDefaultEvent from 'helpers/preventDefaultEvent'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useMemo, useState} from 'react'
import {renderFeedByType, renderFeedHeadlineByType,} from 'views/MainPage/functions/renderFeedItem'
import {fromFeedContentTypes} from '../../Feed/Feed'
import '../styles/Segmented.css'
import {NullAsDefault, renderOwnChild} from '../typedefs'
import {IoFilter} from "react-icons/io5";
import {BsCaretDownFill} from "react-icons/bs";

const ContentTypeSelectable = ({
                                   title,
                                   children,
                                   className = 'py-1 border-b border-indigo-500',
                                   options = [],
                                   defaultValue,
                                   onChange = NullAsDefault,
                                   Wrapper = renderOwnChild,
                                   renderItem = renderFeedByType,
                                   renderTitle = (title, widget) => (
                                       <React.Fragment>
                                           {title}
                                           {widget}
                                       </React.Fragment>
                                   ),
                                   renderHeadlineItem = renderFeedHeadlineByType,
                               }) => {
    const t = useTranslate()

    const isIncluded = (value) => options.map((opt) => opt.value).includes(value)

    const defaultSelected = isIncluded(defaultValue)
        ? defaultValue
        : _.get(options, '[0].value')

    const [current, setCurrent] = useState(defaultSelected)

    useEffect(() => {
        setCurrent(defaultSelected)
        if (!isIncluded(defaultValue)) {
            onChange(defaultSelected)
        }
    }, [options, defaultValue, defaultSelected])

    const contentType = fromFeedContentTypes(current)

    const child = useMemo(() => {
        if (_.isEmpty(options)) return null

        return (
            <div className="flex flex-1 items-center gap-2">
                <div className="flex-1">
                    {renderTitle(
                        title,
                    )}
                </div>
                <DrawMenu
                    menu={
                        {
                            items: options.map(({label, value, icon, ...option}) => ({
                                label,
                                ...option,
                                key: value,
                                className: value === current ? 'disable' : undefined,
                            })),
                            onClick: ({key}) => {
                                setCurrent(key)
                                onChange(key)
                            }
                        }
                    }
                    component={
                        <div
                            onClick={preventDefaultEvent}
                            style={{padding: '0.375rem 0.75rem', minWidth: 160, fontSize: 12, borderRadius: '0.5rem'}}
                            className="p-2 background border border-color-50 hover:shadow w-fit flex items-center italic cursor-pointer">
                            <IoFilter size={13} className="mr-1 text-color-200"/>
                            <span className="text-color-300 tracking-wider">
                                {`${t('filtered by')}: `}
                            </span>
                            <span className="ml-1 font-semibold text-indigo-600 tracking-wider leading-tight">
                                {t(_.get(contentType, 'label'))}
                            </span>
                            <BsCaretDownFill size={12} onClick={preventDefaultEvent} className="ml-2 text-color-400 hover:text-indigo-600"/>
                        </div>
                    }
                />
            </div>
        )
    }, [options, current, contentType, renderTitle])

    return (
        <Wrapper>
            <div className={classNames('select-filter-news', className)}>
                <div className="flex-1"/>
                <div className="flex w-full items-center">{child}</div>
            </div>
            {children([current, setCurrent], {
                limit: 10,
                auto: true,
                alwaysVisible: true,
                renderItem: renderItem(current),
                renderHeadlineItem: renderHeadlineItem(current),
            })}
        </Wrapper>
    )
}

export default ContentTypeSelectable
